import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { LogoutComponent } from './logout/logout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'idp-configurations',
    pathMatch: 'full',
  },
  {
    path: 'idp-configuration/:id',
    loadChildren: () =>
      import('./idp-configuration/idp-configuration.module').then(
        (m) => m.IdpConfigurationModule,
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'idp-configuration',
    loadChildren: () =>
      import('./idp-configuration/idp-configuration.module').then(
        (m) => m.IdpConfigurationModule,
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'wizard-idp-configuration',
    loadChildren: () =>
      import('./wizard-idp-configuration/wizard-idp-configuration.module').then(
        (m) => m.WizardIdpConfigurationModule,
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'wizard-idp-configuration/:id',
    loadChildren: () =>
      import('./wizard-idp-configuration/wizard-idp-configuration.module').then(
        (m) => m.WizardIdpConfigurationModule,
      ),
    canActivate: [OktaAuthGuard],
  },
  { path: 'login/callback', component: OktaCallbackComponent },
  {
    path: 'idp-configurations',
    loadChildren: () =>
      import('./idp-configurations/idp-configurations.module').then(
        (m) => m.IdpConfigurationsModule,
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: '**',
    loadChildren: () =>
      import('./errors/errors.module').then((m) => m.ErrorsModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
